export const CONFIG = {
  WHATSAPP_NUMBER: '50685316690', // Editable
  EXPRESS_FEE: 1500, // Editable, in colones
  CURRENCY_SYMBOL: '₡',
  LOGO_URL:
    'https://cdn.magicpatterns.com/uploads/gZe4Ujh8iFsaCkGQEz5D56/hf_20260311_154212_0e2ca096-fc1e-4614-a1ab-289333fda79d.png',
  APP_NAME: 'Distrito LS',
  APP_TAGLINE: 'Donde Los Santos viene a comer 🔥',
}
